import { render } from "./qna.vue?vue&type=template&id=f9bb7974&scoped=true"
import script from "./qna.vue?vue&type=script&lang=js"
export * from "./qna.vue?vue&type=script&lang=js"

import "./qna.vue?vue&type=style&index=0&id=f9bb7974&lang=scss&scoped=true"
import "./qna.vue?vue&type=style&index=1&id=f9bb7974&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bb7974"]])

export default __exports__